import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  img: {
    width: 'auto',
    height: 38,
  },
});

const LogoIcon = () => {
  const classes = useStyles();

  return (
    <img
      className={classes.img}
      src="/iC-Logo.png"
      alt="Logo Icon"
    />
  );
};

export default LogoIcon;
